import { render } from "./PropertyBanner.vue?vue&type=template&id=b9aa64a2&scoped=true"
import script from "./PropertyBanner.vue?vue&type=script&lang=js"
export * from "./PropertyBanner.vue?vue&type=script&lang=js"

import "./PropertyBanner.vue?vue&type=style&index=0&id=b9aa64a2&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9aa64a2"]])

export default __exports__